import React from 'react';
import PropTypes from 'prop-types';
import SMFormSelectBox from 'components/dashboard/form/SMFormSelectBox';
import SMFormTextField from 'components/dashboard/form/SMFormTextField';
import SMReservationHelper from 'components/helpers/SMReservationHelper';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMReservationEditViewRentalSchedule extends React.Component{

  selectBoxDidChangeValue(e) {
    if(this.props.plan.has_session_price) {
      this.props.delegate.changeScheduleHourButtonAtSession(e.currentTarget.name, e.currentTarget.value);
    } else {
      this.props.delegate.changeScheduleHourButton(e.currentTarget.name, e.currentTarget.value);
    }
  }

  radioButtonDidChangeValue(e) {
    if(this.props.delegate && typeof this.props.delegate.changeHourlyDailyButton === 'function') {
      this.props.delegate.changeHourlyDailyButton(e.currentTarget.name, e.currentTarget.value);
    }
  }

  checkBoxDidChangeValue(e) {
    this.props.delegate.changeDailyButton(e.currentTarget.checked);
  }

  generateButton(reservation, plan) {
    let buttonSet =[];
    let buttons = [];
    if (plan.has_session_price) {
      buttons.push([
        <input
          type="radio"
          key='is-hourly-0-radio'
          id="form-radio00__00"
          name="is_session_price"
          checked={true}
          onChange={this.props.delegate.radioButtonDidChangeValue.bind(this)}
          options={{ disabled: !SMReservationHelper.isDetailEditable(reservation) }} />,
        <label
          key='is-hourly-0-label'
          htmlFor="form-radio00__00"
          className="form-radio w160">
          回ごと価格で借りる
        </label>,
      ]);
    } else {
      let isDailyPriceSelected = false;
      let isHourlyPriceSelected = false;

      if (reservation.is_hourly != undefined) {
        isDailyPriceSelected = !reservation.is_hourly;
        isHourlyPriceSelected = reservation.is_hourly;
      } else {
        if ((plan.has_daily_price && plan.has_hourly_price) ||
          plan.has_daily_price) {
          isDailyPriceSelected = true;
          isHourlyPriceSelected = false;
        } else {
          isDailyPriceSelected = false;
          isHourlyPriceSelected = true;
        }
      }

      if (plan.has_daily_price) {
        buttons.push([
          <input
            type="radio"
            key='is-hourly-1-radio'
            value='0'
            id="form-radio00__01"
            name="is_hourly"
            checked={isDailyPriceSelected}
            onChange={this.radioButtonDidChangeValue.bind(this)}
            disabled={!SMReservationHelper.isDetailEditable(reservation)} />,
          <label
            key='is-hourly-1-label'
            htmlFor="form-radio00__01"
            className="form-radio w150">
            終日価格で借りる
          </label>,
        ]);

      }

      if (plan.has_hourly_price) {
        buttons.push([
          <input
            type="radio"
            key='is-hourly-2-radio'
            value='1' id="form-radio00__02"
            name="is_hourly"
            checked={isHourlyPriceSelected}
            onChange={this.radioButtonDidChangeValue.bind(this)}
            disabled={!SMReservationHelper.isDetailEditable(reservation)} />,
          <label
            key='is-hourly-2-label'
            htmlFor="form-radio00__02"
            className="form-radio w150">
            時間価格で借りる
          </label>
        ]);
      }

      buttonSet = <p className="mb20">{buttons}</p>;
    }
    
    return buttonSet;
  }



  generatePullDownStartedDate(room, strStartedHour, reservation) {
    var canDisplay = false;
    if (this.props.plan) {
      if (this.props.plan.has_session_price) {
        canDisplay = this.props.delegate.isReservationHourly() && this.props.plan.min_required_session_hour_unit == 0;
      } else {
        canDisplay = this.props.delegate.isReservationHourly();
      }
    } else {
      canDisplay = this.props.delegate.isReservationHourly();
    }
    if (canDisplay) {
      // チェックイン時刻セレクトボックスのvalue郡を作成
      let selectBoxItems = [];
      selectBoxItems.push({value: -1, label: ''});

      for (let i = 0; i <= 24; i++) {
        let checkinTimeZero = i.toString() + ":00";

        selectBoxItems.push({
          value: checkinTimeZero,
          label: checkinTimeZero
        });
      }

      return (
        <span className="form-select__inner ml5">
          <label className="form-select">
            <SMFormSelectBox
              name='started_hour'
              ref='startedHour'
              items={selectBoxItems}
              selectedValue={strStartedHour}
              delegate={this}
              options={{className: 'w110', disabled: !SMReservationHelper.isDetailEditable(reservation)}} />
          </label>
        </span>
      );
    } else {
      return null;
    }
  }

  generatePullDownEndedDate(room, strEndedHour, reservation) {
    var canDisplay = false;
    if (this.props.plan) {
      if (this.props.plan.has_session_price) {
        canDisplay = this.props.delegate.isReservationHourly() && this.props.plan.min_required_session_hour_unit == 0;
      } else {
        canDisplay = this.props.delegate.isReservationHourly();
      }
    } else {
      canDisplay = this.props.delegate.isReservationHourly();
    }

    if (canDisplay) {
      // チェックイン時刻セレクトボックスのvalue郡を作成
      let selectBoxItems = [];
      selectBoxItems.push({value: -1, label: ''});

      for (let i = 0; i <= 24; i++) {
        let checkinTimeZero = i.toString() + ":00";

        selectBoxItems.push({
          value: checkinTimeZero,
          label: checkinTimeZero
        });
      }

      return (
        <span className="form-select__inner ml5">
          <label className="form-select">
            <SMFormSelectBox
              name='ended_hour'
              ref='endedHour'
              items={selectBoxItems}
              selectedValue={strEndedHour}
              delegate={this}
              options={{className: 'w110', disabled: !SMReservationHelper.isDetailEditable(reservation)}} />
          </label>
        </span>
      );
    } else {
      return null;
    }
  }

  render() {
    const reservation = this.props.reservation;
    const plan = this.props.plan;
    const room = this.props.room;
    const errors = this.props.errors;
    const strStartedDate = this.props.startedDate ?this.props.startedDate.getFullYear() + '/'
      + ("0" + (this.props.startedDate.getMonth() + 1)).slice(-2) + '/'
      + ("0" + (this.props.startedDate.getDate())).slice(-2) : null;
    const strStartedHour = this.props.startedHour ? this.props.startedHour + ":" + "00" : null;
    const strEndedHour = this.props.endedHour ? this.props.endedHour + ":" + "00" : null;
    
    let strEndedDate = this.props.endedDate ? this.props.endedDate.getFullYear() + '/'
    + ("0" + (this.props.endedDate.getMonth() + 1)).slice(-2) + '/'
    + ("0" + (this.props.endedDate.getDate())).slice(-2) : null;
    
    if (this.props.endedDate && this.props.delegate.isUpdateEndedDateRequirement()) {
      let tmpEndDate = new Date(this.props.endedDate);
      tmpEndDate.setDate(tmpEndDate.getDate() - 1);
      strEndedDate = tmpEndDate.getFullYear() + '/'
        + ("0" + (tmpEndDate.getMonth() + 1)).slice(-2) + '/'
        + ("0" + (tmpEndDate.getDate())).slice(-2);
    }

    return (
      <td>
        {this.generateButton(reservation, plan)}
        <SMFormTextField
          name="started_date"
          ref='startedDate'
          value={strStartedDate}
          options={{
            className: 'w110 js-datepicker',
            disabled: !SMReservationHelper.isDetailEditable(reservation)
          }}
          placeholderText='20151201'
          delegate={this} />
        {this.generatePullDownStartedDate(room, strStartedHour, reservation)}
        <span className="ml5 mr5">〜</span>
        <SMFormTextField
          name="ended_date"
          ref='endedDate'
          value={strEndedDate}
          options={{
            className: 'w110 js-datepicker',
            disabled: !SMReservationHelper.isDetailEditable(reservation)
          }}
          placeholderText='20151201'
          delegate={this} />
        {this.generatePullDownEndedDate(room, strEndedHour, reservation)}
        <span className="message-important ml10">{SMFormatHelper.errorText('Reservation', 'schedules', errors)}</span>
        {this.props.delegate.renderCalendarLink()}
      </td>
    );
  }
}

SMReservationEditViewRentalSchedule.propTypes = {
  reservation: PropTypes.object.isRequired,
  room: PropTypes.object.isRequired,
  plan: PropTypes.object.isRequired,
  startedDate: PropTypes.object.isRequired,
  startedHour: PropTypes.number.isRequired,
  endedDate: PropTypes.object.isRequired,
  endedHour: PropTypes.number.isRequired,
  errors: PropTypes.array,
  delegate: PropTypes.object.isRequired
};

export default SMReservationEditViewRentalSchedule;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/shared/SMReservationEditViewRentalSchedule.jsx